/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BackendApiApiV2ActualVehicleStateVehicleGPSData
 */
export interface BackendApiApiV2ActualVehicleStateVehicleGPSData {
    /**
     * 
     * @type {Date}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleGPSData
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleGPSData
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleGPSData
     */
    lon: number;
    /**
     * 
     * @type {number}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleGPSData
     */
    alt?: number;
    /**
     * 
     * @type {number}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleGPSData
     */
    speed?: number;
    /**
     * 
     * @type {number}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleGPSData
     */
    angle?: number;
}

export function BackendApiApiV2ActualVehicleStateVehicleGPSDataFromJSON(json: any): BackendApiApiV2ActualVehicleStateVehicleGPSData {
    return BackendApiApiV2ActualVehicleStateVehicleGPSDataFromJSONTyped(json, false);
}

export function BackendApiApiV2ActualVehicleStateVehicleGPSDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackendApiApiV2ActualVehicleStateVehicleGPSData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': (new Date(json['time'])),
        'lat': json['lat'],
        'lon': json['lon'],
        'alt': !exists(json, 'alt') ? undefined : json['alt'],
        'speed': !exists(json, 'speed') ? undefined : json['speed'],
        'angle': !exists(json, 'angle') ? undefined : json['angle'],
    };
}

export function BackendApiApiV2ActualVehicleStateVehicleGPSDataToJSON(value?: BackendApiApiV2ActualVehicleStateVehicleGPSData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': (value.time.toISOString()),
        'lat': value.lat,
        'lon': value.lon,
        'alt': value.alt,
        'speed': value.speed,
        'angle': value.angle,
    };
}


